import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Register.css';
import api from './Api';
import Header from './Header';

const Register = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    name: '',
    gender: '',
    email: '',
    phone: ''
  });

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
    setSuccess('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post('/auth/register', formData);
      if (response) {
        setSuccess('Registration successful! Redirecting to login...');
        setTimeout(() => navigate('/login'), 2000);
      }
    } catch (error) {
      setError('Registration failed. Please try again!');
      console.error('Error registering:', error);
    }
  };

  return (
    <div>
      <Header />
      <div className="register-container">
        <div className="register-card">
          <h2 className="register-title">Create an Account</h2>
          {error && <p className="error-text">{error}</p>}
          {success && <p className="success-text">{success}</p>}

          <form onSubmit={handleSubmit} className="register-form">
            <div className="form-group">
              <label className="form-label">Full Name</label>
              <input type="text" name="name" value={formData.name} onChange={handleChange} required className="form-input" placeholder="Enter your full name" />
            </div>

            <div className="form-group">
              <label className="form-label">Gender</label>
              <select name="gender" value={formData.gender} onChange={handleChange} required className="form-select">
                <option value="">Select Gender</option>
                <option value="MALE">Male</option>
                <option value="FEMALE">Female</option>
                <option value="OTHER">Other</option>
              </select>
            </div>

            <div className="form-group">
              <label className="form-label">Email</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} required className="form-input" placeholder="Enter your email" />
            </div>

            <div className="form-group">
              <label className="form-label">Phone</label>
              <input type="text" name="phone" value={formData.phone} onChange={handleChange} required className="form-input" placeholder="Enter your phone number" />
            </div>

            <div className="form-group">
              <label className="form-label">Username</label>
              <input type="text" name="username" value={formData.username} onChange={handleChange} required className="form-input" placeholder="Choose a username" />
            </div>

            <div className="form-group">
              <label className="form-label">Password</label>
              <input type="password" name="password" value={formData.password} onChange={handleChange} required className="form-input" placeholder="Enter a strong password" />
            </div>

            <button type="submit" className="form-button">Register</button>
          </form>

          <p className="login-link">
            Already have an account? <span onClick={() => navigate('/login')}>Login here</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;
